<template>
  <div :style="style.container">
    <div :style="style.leftContainer">
      <div :style="style.popoverContainer">
        <PopoverSecondary
          v-bind="getVisibilityPopoverAttrs"
          :disablePopover="!showVisibilityWarning"
          :horizontalPosition="'left'"
          :style="style.popover"
        >
          <template v-slot:trigger>
            <IconVisibility
              :disabled="viewOnly"
              :style="style.iconVisibility"
              :visible="skillNode.visible"
              @click="switchSkillVisibility"
            />
          </template>
          <template v-slot:content>
            <div :style="style.popoverText">
              Required skill can't be hidden.
            </div>
          </template>
        </PopoverSecondary>
      </div>
      <div :style="getSkillNameStyle">
        {{ skillNode.name }}
      </div>
    </div>
    <div
      v-if="!viewOnly"
      :style="style.rightContainer"
    >
      <div :style="style.popoverContainer">
        <PopoverSecondary
          v-bind="attrs.popover"
          :horizontalPosition="'right'"
          :style="style.popover"
        >
          <template v-slot:trigger>
            <IconBookmark
              :marked="skillNode.required"
              :style="style.iconBookmark"
              @click="switchSkillNecessity"
            />
          </template>
          <template v-slot:content>
            <template v-if="skillNode.required">
              <div :style="style.popoverText">
                Unmark as required
              </div>
            </template>
            <template v-else>
              <div :style="style.popoverText">
                Mark as required
              </div>
            </template>
          </template>
        </PopoverSecondary>
      </div>
    </div>
  </div>
</template>

<script>
  import IconBookmark from '@modules/icon/icon-bookmark'
  import IconVisibility from '@modules/icon/icon-visibility'
  import PopoverSecondary from '@modules/popover/popover-secondary'
  import { FontStyle, Layout } from '@js/styles'
  import { mapGetters } from 'vuex'

  export default {
    name: 'SkillListRow',
    components: {
      IconBookmark,
      IconVisibility,
      PopoverSecondary,
    },
    props: {
      skillNode: { type: Object, required: false, default: () => {} },
      viewOnly: { type: Boolean, required: false, default: true },
    },
    data: function () {
      return {
        attrs: {
          icon: {
            content: 'bookmark',
            fontSize: FontStyle.size.md,
          },
          popover: {
            byMouseover: true,
            byMouseout: true,
          },
        },
        style: {
          container: {
            alignItems: 'center',
            display: 'flex',
            height: '51px',
            justifyContent: 'space-between',
            padding: `0 ${Layout.space.md}`,
            width: '100%',
          },
          iconBookmark: {
            margin: '2px 0 0 0',
          },
          icon: {
            margin: '2px 0 0 0',
            cursor: 'pointer',
          },
          iconVisibility: {
            margin: `0 ${Layout.space.sm} 0 0`,
          },
          leftContainer: {
            alignItems: 'center',
            display: 'flex',
            height: '100%',
            justifyContent: 'flex-start',
          },
          popoverContainer: {
            alignItems: 'center',
            display: 'flex',
            height: '100%',
            justifyContent: 'flex-end',
            position: 'relative',
            width: '20px',
          },
          popover: {
            alignItems: 'center',
            display: 'flex',
            height: '100%',
            position: 'absolute',
            width: '20px',
          },
          popoverText: {
            fontSize: FontStyle.size.sm,
            whiteSpace: 'nowrap',
          },
          rightContainer: {
            alignItems: 'center',
            display: 'flex',
            height: '100%',
            justifyContent: 'flex-end',
          },
        },
      };
    },
    computed: {
      ...mapGetters('colorTheme', ['color']),
      getSkillNameStyle: function () {
        return {
          color: this.skillNode.visible ? '' : this.color.dark4(),
        };
      },
      getVisibilityPopoverAttrs: function () {
        return {
          byMouseover: true,
          byMouseout: true,
          disablePopover: !this.showVisibilityWarning,
        };
      },
      showVisibilityWarning: function () {
        return !this.viewOnly && this.skillNode.required && this.skillNode.visible;
      },
    },
    methods: {
      switchSkillNecessity: function () {
        if (this.skillNode.required) {
          this.$emit('unmark-as-required', this.skillNode);
        } else {
          this.$emit('mark-as-required', this.skillNode);
        }
      },
      switchSkillVisibility: function () {
        if (this.viewOnly) {
          return;
        }

        if (this.skillNode.visible) {
          if (!this.skillNode.required) {
            this.$emit('unselect', this.skillNode);
          }
        } else {
          this.$emit('select', this.skillNode);
        }
      },
    },
  };
</script>
